module.exports = __webpack_public_path__ + "static/media/MADEINUSAICON-01.d38cdf13.svg";